export default [
    {
        "id": '160',
        "title": "数据中心",
        "path": "datacentre",
        "component": "datacentre",
        "pid": 0,
        "icon": "monitor",
        "type": 1,
        "hide": 0,
        "sort": 1,
        "type_format": "菜单",
        "children": [{
            "id": 'A2',
            "title": "数据中心",
            "path": "datacenter",
            "component": "datacenter",
            "pid": '160',
            "icon": "",
            "type": 2,
            "hide": 0,
            "sort": 1,
            "type_format": "节点",
            "children": []
        },]
    },
    {
        "id": '170',
        "title": "故障记录",
        "path": "malfunction",
        "component": "malfunction",
        "pid": 0,
        "icon": "skill",
        "type": 1,
        "hide": 1,
        "sort": 2,
        "type_format": "菜单",
        "children": [
            {
                "id": '170',
                "title": "故障记录",
                "path": "malfunctions",
                "component": "malfunctions",
                "pid": 'B1',
                "icon": "",
                "type": 2,
                "hide": 0,
                "sort": 1,
                "type_format": "节点",
                "children": []
            },
        ]
    },
    {
        "id": '90',
        "title": "工地管理",
        "path": "constructionsite",
        "component": "constructionsite",
        "pid": 0,
        "icon": "mycompany",
        "type": 1,
        "hide": 0,
        "sort": 3,
        "type_format": "菜单",
        "children": [
            {
                "id": 'C2',
                "title": "工地管理",
                "path": "constructionsites",
                "component": "constructionsites",
                "pid": '90',
                "icon": "",
                "type": 2,
                "hide": 0,
                "sort": 1,
                "type_format": "节点",
                "children": []
            },
        ]
    },
    {
        // "id": 'D1',
        "id": '80',
        "title": "设备管理",
        "path": "equipmentmsg",
        "component": "equipmentmsg",
        "pid": 0,
        "icon": "textarea",
        "type": 1,
        "hide": 0,
        "sort": 4,
        "type_format": "菜单",
        "children": [
            {
                "id": 'D2',
                "title": "设备管理",
                "path": "equipmentmsgs",
                "component": "equipmentmsg",
                "pid": 'D1',
                "icon": "",
                "type": 2,
                "hide": 0,
                "sort": 1,
                "type_format": "节点",
                "children": []
            },
        ]
    },
    {
        "id": '2049',
        "title": "出入库管理",
        "path": "inoutlibrary",
        "component": "inoutlibrary",
        "pid": 0,
        "icon": "redis",
        "type": 1,
        "hide": 1,
        "sort": 5,
        "type_format": "菜单",
        "children": [
            {
                "id": 'E2',
                "title": "出入库管理",
                "path": "inoutlibrarys",
                "component": "inoutlibrarys",
                "pid": 'E1',
                "icon": "build",
                "type": 2,
                "hide": 1,
                "sort": 1,
                "type_format": "节点",
                "children": []
            },
        ]
    },
    {
        // "id": 'F1',
        "id": '150',
        "title": "账号列表",
        "path": "userlist",
        "component": "userlist",
        "pid": 0,
        "icon": "peoples",
        "type": 1,
        "hide": 0,
        "sort": 6,
        "type_format": "菜单",
        "children": [
            {
                "id": 'F2',
                "title": "账号列表",
                "path": "userlists",
                "component": "userlists",
                "pid": 'F1',
                "icon": "build",
                "type": 2,
                "hide": 0,
                "sort": 1,
                "type_format": "节点",
                "children": []
            },
        ]
    },
    {
        "id": '2050',
        "title": "基础信息",
        "path": "basicsmsg",
        "component": "basicsmsg",
        "pid": 0,
        "icon": "logininfor",
        "type": 1,
        "hide": 0,
        "sort": 7,
        "type_format": "菜单",
        "children": [
            {
                "id": 'G2',
                "title": "基础信息",
                "path": "basicsmsgs",
                "component": "basicsmsgs",
                "pid": 'G1',
                "icon": "build",
                "type": 2,
                "hide": 0,
                "sort": 1,
                "type_format": "节点",
                "children": []
            },
        ]
    },
    {
        "id": '180',
        "title": "数据导出",
        "path": "dataderive",
        "component": "dataderive",
        "pid": 0,
        "icon": "chart",
        "type": 1,
        "hide": 0,
        "sort": 8,
        "type_format": "菜单",
        "children": [
            {
                "id": 'H2',
                "title": "数据导出",
                "path": "dataderives",
                "component": "dataderives",
                "pid": '180',
                "icon": "build",
                "type": 2,
                "hide": 0,
                "sort": 1,
                "type_format": "节点",
                "children": []
            },
        ]
    },
]
